// granary left choose mixin
export const lchooseMixin = {
  data() {
    return {
      active: -1,
      navList: []
    };
  },
  methods: {
    onChange(i) {
      if (this.active !== i) {
        this.active = i;
        if (this.navList[i]["children"]) {
          // 如果有子栏目
          let index = this.navList[i]["children"].findIndex(e => {
            return e.active === true;
          });
          this.$bus.$emit(
            "zlchange",
            this.navList[i]["children"][index]["name"]
          );
        } else {
          //无子栏目
          this.$bus.$emit("zlchange", this.navList[i]["name"]);
        }
      }
    },
    onChange2(i) {
      if (this.navList[this.active]["children"][i]["active"] !== true) {
        this.navList[this.active]["children"].forEach(e => {
          if (e.active) {
            e.active = false;
          }
        });
        this.navList[this.active]["children"][i]["active"] = true;
        this.$bus.$emit(
          "zlchange",
          this.navList[this.active]["children"][i]["name"]
        );
      }
    }
  },
  mounted() {
    if (this.active === -1) {
      this.onChange(0);
    }
  }
};
